module.exports = __webpack_public_path__ + "static/media/todo-complete-light.8dc1af4a.svg";